import {SPORT_TYPES} from "constants/WindAnalysisConstants.js";

/**
 * @param {number|null|undefined} waterSportId
 * @return {boolean}
 */
export function isSailingSport(waterSportId: number | null | undefined): boolean {
  if (!waterSportId) {
    return false;
  }
  return SPORT_TYPES.SAILING.includes(Number(waterSportId));
}
